export default __webpack_public_path__ + "static/media/messwala.96cd3cbd.jpg";